export class WebsocketsInitializer {
    static websockets() {
        // require('./websockets/workspace-switch');
    }
}